import SAPOMailConfig   from "@/SAPOMailConfig";
import EventBroadcaster from "../Common/Events/EventBroadcaster";
import Events           from "../Common/Events/Events";

export { PreLoaderControllerSingleton as default };

/**
* PreLoader controller
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class PreLoaderController {
  /**
   * Caches PreLoader circle
   *
   * @param {Node}
   *
   * @private
   *
   * @since 7.0.0
   */
  preloader;

  /**
   * Caches PreLoader circle node element
   *
   * @param {Node}
   *
   * @private
   *
   * @since 7.0.0
   */
  preloader_circle;

  /**
   * Pre Loaded started timestamp
   *
   * @param {Number}
   *
   * @private
   *
   * @since 7.0.0
   */
  timestamp;

  /**
   * Preloader progress percentage
   *
   * @param {Number}
   *
   * @private
   *
   * @since 7.0.0
   */
  percentage = 0;

  /**
   * Preload Interval id
   *
   * @param {Number}
   *
   * @private
   *
   * @since 7.0.0
   */
  interval;

  /**
   * Caches dom elements needed to work
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {void}
   */
  load() {
    this.preloader        = document.getElementById('preloader');
    this.preloader_circle = document.getElementById('preloader-circle');
    this.setOffset(0);
  }

  /**
   * Starts the pre loader progress animation
   *
   * @since 7.0.0
   *
   * @return {void}
   */
  start() {
    if (SAPOMailConfig.client.preloader.enabled === true) {
      this.preloader.style.display = 'flex';
    }

    this.timestamp = Date.now();

    this.interval = setInterval(() => {
      this.setOffset(this.percentage + 10);
    }, 200);
  }

  /**
   * Stops the preloader interval
   *
   * @since 7.0.0
   *
   * @param {String} percentage progress offset percentage (1-100)
   *
   * @return {void}
   */
  stop() {
    clearInterval(this.interval);
  }

  /**
   * Sets the pre loader progess offset
   *
   * @since 7.0.0
   *
   * @param {String} percentage progress offset percentage (1-100)
   *
   * @return {void}
   */
  setOffset(percentage) {
    let circumference                            = this.preloader_circle.r.baseVal.value * 2 * Math.PI;
    this.percentage                              =  percentage;
    this.preloader_circle.style.strokeDasharray  = `${circumference} ${circumference}`;
    this.preloader_circle.style.strokeDashoffset = circumference - this.percentage / 100 * circumference;
  }

  /**
   * Removes Pre Loader from dom
   *
   * @since 7.0.0
   *
   * @return {void}
   */
  remove() {
    let duration = Date.now() - this.timestamp;
    let interval = 0;

    if (duration < 1000) {
      interval = 1000 - duration;
    }

    setTimeout(() => {
      this.setOffset(100);
      this.stop();

      setTimeout(() => {
        this.preloader.remove();
        EventBroadcaster.broadcast(Events.APPLICATION_PRELOADER_REMOVED);
      }, SAPOMailConfig.client.preloader.closing_delay)

    }, interval);
  }
}

const PreLoaderControllerSingleton = new PreLoaderController();